var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { apiFetch, StyledButton, StyledButtonStyle, useData, } from "ee-react-components";
import { orchestratorUrl } from "./api";
import { ResponseFormDialog } from "./ResponseFormDialog";
var responsesKey = function () { return "".concat(orchestratorUrl(), "/responses"); };
export var ResponsesTab = function () {
    var _a;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _b = useData(responsesKey()), responses = _b.data, refresh = _b.execute;
    var _c = useState(false), dialogOpen = _c[0], setDialogOpen = _c[1];
    var _d = useState(null), editing = _d[0], setEditing = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    var onNew = useCallback(function () {
        setEditing(null);
        setDialogOpen(true);
    }, []);
    var onEdit = useCallback(function (row) {
        setEditing(row);
        setDialogOpen(true);
    }, []);
    var onDelete = useCallback(function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var getToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm("Delete response \"".concat(row.name, "\"?")))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/responses/").concat(row.id), {
                            method: "DELETE",
                            callbacks: { getToken: getToken },
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently, refresh]);
    var onCloseDialog = useCallback(function () { return setDialogOpen(false); }, []);
    var onSavedDialog = useCallback(function () { return void refresh(); }, [refresh]);
    return (React.createElement("div", { className: "flex flex-col gap-y-[24px]" },
        React.createElement("div", { className: "flex flex-row items-center justify-between" },
            React.createElement("h2", { className: "text-white font-N6" }, "Responses"),
            React.createElement(StyledButton, { text: "New response", onClick: onNew })),
        error && React.createElement("div", { className: "text-red font-N8" }, error),
        !responses && React.createElement("span", { className: "text-black-600 font-N8" }, "Loading\u2026"),
        responses && responses.length === 0 && (React.createElement("span", { className: "text-black-600 font-N8" }, "No responses defined.")),
        responses && responses.length > 0 && (React.createElement("div", { className: "flex flex-col rounded-[10px] overflow-hidden border border-black-800" },
            React.createElement("div", { className: "grid grid-cols-[3fr_3fr_1fr] bg-black-900 px-[12px] py-[8px] text-black-400 font-N8 uppercase text-[10px] tracking-wide" },
                React.createElement("span", null, "Name"),
                React.createElement("span", null, "Phases"),
                React.createElement("span", null, "Version")),
            responses.map(function (r) {
                var phaseSummary = phaseList(r).join(", ");
                return (React.createElement(Disclosure, { key: r.id }, function (_a) {
                    var open = _a.open;
                    return (React.createElement("div", null,
                        React.createElement(Disclosure.Button, { className: "w-full text-left grid grid-cols-[3fr_3fr_1fr] px-[12px] py-[10px] border-t border-black-800 hover:bg-black-900 transition-colors" },
                            React.createElement("span", { className: "text-white font-N8" }, r.name),
                            React.createElement("span", { className: "text-white font-N8" }, phaseSummary),
                            React.createElement("span", { className: "text-white font-N8 flex items-center gap-x-[4px]" },
                                "v",
                                r.version,
                                React.createElement(ChevronDownIcon, { className: "w-[12px] h-[12px] ml-auto text-black-600 transition-transform ".concat(open ? "" : "rotate-180") }))),
                        React.createElement(Disclosure.Panel, null,
                            React.createElement(ResponseExpansion, { response: r, onEdit: function () { return onEdit(r); }, onDelete: function () { return void onDelete(r); } }))));
                }));
            }))),
        React.createElement(ResponseFormDialog, { key: (_a = editing === null || editing === void 0 ? void 0 : editing.id) !== null && _a !== void 0 ? _a : "new", open: dialogOpen, existing: editing, onClose: onCloseDialog, onSaved: onSavedDialog })));
};
// ─── Response expansion ─────────────────────────────────────────────────────
var ResponseExpansion = function (_a) {
    var _b, _c;
    var response = _a.response, onEdit = _a.onEdit, onDelete = _a.onDelete;
    return (React.createElement("div", { className: "border-t border-black-800 bg-black-1100 p-[16px] flex flex-col gap-y-[16px]" },
        React.createElement("div", { className: "grid grid-cols-2 gap-x-[24px] gap-y-[12px]" },
            React.createElement(Param, { label: "Description", value: response.description || "-" }),
            React.createElement(Param, { label: "Version", value: "v".concat(response.version) })),
        React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
            response.beforePowerProfile && (React.createElement(PhaseCard, { title: "Before", subtitle: "".concat((_b = response.beforeOffsetMinutes) !== null && _b !== void 0 ? _b : 0, "m before event"), profile: response.beforePowerProfile })),
            response.duringPowerProfile && (React.createElement(PhaseCard, { title: "During", subtitle: "event window", profile: response.duringPowerProfile })),
            response.afterPowerProfile && (React.createElement(PhaseCard, { title: "After", subtitle: "".concat((_c = response.afterOffsetMinutes) !== null && _c !== void 0 ? _c : 0, "m after event"), profile: response.afterPowerProfile }))),
        React.createElement("div", { className: "flex flex-row gap-x-[8px]" },
            React.createElement(StyledButton, { text: "Edit", onClick: onEdit }),
            React.createElement(StyledButton, { text: "Delete", style: StyledButtonStyle.Gray, onClick: onDelete }))));
};
var PhaseCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, profile = _a.profile;
    return (React.createElement("div", { className: "border border-black-800 rounded-[10px] p-[12px] flex flex-col gap-y-[8px]" },
        React.createElement("div", { className: "flex flex-row items-baseline gap-x-[8px]" },
            React.createElement("span", { className: "text-white font-N7 uppercase" }, title),
            React.createElement("span", { className: "text-black-500 font-N8" }, subtitle)),
        React.createElement("div", { className: "grid grid-cols-2 gap-x-[24px] gap-y-[12px]" },
            React.createElement(Param, { label: "Grid limit (kW)", value: profile.gridLimit == null ? "-" : String(profile.gridLimit) }),
            React.createElement(Param, { label: "Max battery SOC (%)", value: profile.maxBatterySoc == null ? "-" : String(profile.maxBatterySoc) }),
            React.createElement(Param, { label: "Grid-use-first above target SOC (kW)", value: profile.gridUseFirstAboveTargetSoc == null
                    ? "-"
                    : String(profile.gridUseFirstAboveTargetSoc) }),
            React.createElement(Param, { label: "Grid-use-first below target SOC (kW)", value: profile.gridUseFirstBelowTargetSoc == null
                    ? "-"
                    : String(profile.gridUseFirstBelowTargetSoc) }),
            React.createElement(Param, { label: "Recharge to target", value: profile.rechargeToTarget ? "yes" : "no" }))));
};
var Param = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement("div", { className: "flex flex-col gap-y-[2px]" },
        React.createElement("span", { className: "text-black-500 uppercase text-[10px] tracking-[0.08em] font-semibold" }, label),
        React.createElement("span", { className: "text-white font-N7 text-[14px]" }, value)));
};
var phaseList = function (r) {
    var _a, _b;
    var parts = [];
    if (r.beforePowerProfile)
        parts.push("before (".concat((_a = r.beforeOffsetMinutes) !== null && _a !== void 0 ? _a : 0, "m)"));
    parts.push("during");
    if (r.afterPowerProfile)
        parts.push("after (".concat((_b = r.afterOffsetMinutes) !== null && _b !== void 0 ? _b : 0, "m)"));
    return parts;
};
